"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODOS_PESAGEM = void 0;
exports.MODOS_PESAGEM = ['SAIDA', 'DEVOLUCAO', 'PERDA'];
//# sourceMappingURL=estoque-tinta.js.map